module.exports = __webpack_public_path__ + "static/media/repeat.3e8b18a8.svg";